<template>

    <h1>Υπό Κατασκευή</h1>
   <img src="@/assets/Construction crane-amico.svg" alt="eShop Development" />
    </template>
  
  <script>
  export default {
    name: 'WebApps'
  };
  </script>
  
  <style scoped>
  
  h1{
    text-align: center;
    font-size: 2em;
    margin-top: 20px;
    color: #FFC947;
  }
  
  
  img {
    width: 30%;
    height: auto;
    display: block;
    margin: 0 auto;
    margin-bottom: 20%;
    margin-top: 5%;
    animation: fadeIn 1s ease-in-out;
  }
  
  </style>
  